import { loadGoogleFontsForVariants } from "@universe/fonts";

let loadPromise;

export function loadWavemakerFonts() {
  if (loadPromise || typeof document === "undefined" || !document.fonts) {
    return loadPromise;
  }

  const variants = [
    { family: "Montserrat", weight: 400, style: "normal" },
    { family: "Montserrat", weight: 600, style: "normal" },
    { family: "Montserrat", weight: 900, style: "normal" },
  ];

  loadPromise = loadGoogleFontsForVariants(variants, document.fonts);
  return loadPromise;
}
